window.arAuditDetailFormatter = function(value, row) {
    let html = '';
    let json_old_values = JSON.parse(row.json_old_values);
    let json_new_values = JSON.parse(row.json_new_values);
    html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<th style="padding: 8px; width: 220px !important">'+__('Column')+'</th>';
    if (row.raw_event !== "created") {
        html += '<th style="padding: 8px; width: 220px !important">' + __('Old Value') + '</th>';
    }
    if (row.raw_event !== "deleted") {
        html += '<th style="padding: 8px; width: 220px !important">' + __('New Value') + '</th>';
    }
    html += '<th>&nbsp;</th>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    let values = row.raw_event === "created" ? json_new_values : json_old_values;
    if (values != null && Object.keys(values).length > 0) {
        let keys = Object.keys(values);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            html += '<tr>';
            // Column
            html += '<td style="padding: 8px">'+key+'</th>';
            // Old Value
            if (row.raw_event !== "created") {
                html += '<td style="padding: 8px !important; background: #FFE9E9 !important; color: #333 !important">';
                html += json_old_values[key];
                html += '</th>';
            }
            // New Value
            if (row.raw_event !== "deleted") {
                html += '<td style="padding: 8px!important; background: #E9FFE9 !important; color: #333 !important">';
                html += json_new_values[key];
                html += '</th>';
            }
            html += '<td>&nbsp;</td>';
            html += '</tr>';
        }
    }
    html += '</tbody>';
    html += '</table>';
    return html;
};
